import { useRef, useState, useEffect, useCallback } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const useComprobanteTurno = ({ abrir, turno, togleAbrirCerrarComprobanteTurno }) => {
  const componentRef = useRef(null);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [heightIframe, setHeightIframe] = useState(null);
  const [widthIframe, setWidthIframe] = useState(null);
  const [namePdf, setNamePdf] = useState(null);
  const [rendedComponent, setRendedComponent] = useState(false);
  const [rendedMobile, setRendedMobile] = useState(false);

  const TraerServicio = useCallback(async () => {
    try {
      setRendedComponent(true);
    } catch (e) {}
  }, []);

  const handlePrint = useCallback(async () => {
    const elementToCapture = componentRef.current;
    if (!elementToCapture) {
      console.error("No se encontró el elemento para capturar.");
      return;
    }
    try {
      const originalWidth = elementToCapture.scrollWidth;
      const originalHeight = elementToCapture.scrollHeight;
      const scaleFactor = 1.5;
      const scaledWidth = originalWidth * scaleFactor;
      const scaledHeight = originalHeight * scaleFactor;
      const canvas = await html2canvas(elementToCapture, {
        width: originalWidth,
        height: originalHeight,
      });
      canvas.toBlob((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const pdf = new jsPDF();
        pdf.addImage(blobUrl, "PNG", 20, 10, scaledWidth / 7, scaledHeight / 7);
        const generatedPdfBlobUrl = URL.createObjectURL(pdf.output("blob"));
        setPdfBlobUrl(generatedPdfBlobUrl);
        setHeightIframe(scaledHeight);
        setWidthIframe(scaledWidth);
        setNamePdf(`Comprobante-Turno-${turno?.codigo}.pdf`);
      }, "image/png");
    } catch (error) {
      console.error("Error al capturar la pantalla:", error);
    }
  }, [turno]);

  const CargarComprobante = useCallback(async () => {
    if (abrir && !rendedComponent) await TraerServicio();
    if (abrir && rendedComponent && !pdfBlobUrl) await handlePrint();
    if (!abrir && rendedComponent && pdfBlobUrl) {
      setPdfBlobUrl(null);
      setRendedComponent(false);
    }
  }, [abrir, rendedComponent, pdfBlobUrl, TraerServicio, handlePrint]);

  useEffect(() => {
    CargarComprobante();
    // eslint-disable-next-line
  }, [abrir, turno, pdfBlobUrl, rendedComponent]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) {
        setRendedMobile(true);
      } else {
        setRendedMobile(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClose = useCallback(() => {
    togleAbrirCerrarComprobanteTurno();
  }, [togleAbrirCerrarComprobanteTurno]);

  return {
    componentRef,
    pdfBlobUrl,
    heightIframe,
    widthIframe,
    namePdf,
    rendedComponent,
    rendedMobile,
    TraerServicio,
    handlePrint,
    CargarComprobante,
    handleClose,
    setPdfBlobUrl,
    setRendedComponent,
  };
};

export default useComprobanteTurno;
